import type { BillingItem as BillingItemDto, CustomerBillingInfo } from '@mynt/backoffice-api-spec/billables'
import type { BillingItem, Invoice } from './api'

export const mapCustomerBillingInfoToInvoice = (customerBillingInfo: CustomerBillingInfo): Invoice => ({
  total: customerBillingInfo.totalAmount,
  net: customerBillingInfo.totalNetAmount,
  discount: customerBillingInfo.totalDiscountAmount,
  nextInvoiceDate: customerBillingInfo.nextInvoiceDate,
  items: customerBillingInfo.items.map(mapBillableItemDtoToBillingItem),
})

export const mapBillableItemDtoToBillingItem = (billableItem: BillingItemDto): BillingItem => ({
  billableId: billableItem.billableId,
  quantity: billableItem.quantity,
  totalPrice: billableItem.totalPrice,
  discountAmount: billableItem.discountAmount,
  discountedAmount: billableItem.discountedAmount,
})
